import {List} from 'immutable';
import {map} from 'rxjs/operators';

import RESTClient from 'web-app/api/clients/rest-client-famly-app';

const fromApi = (vacationPlan: any) => {
    return {
        ...vacationPlan,
        recipients: List<any>(vacationPlan.recipients).map(recipient => {
            return {
                ...recipient,
                title: recipient.name || recipient.title,
            };
        }),
        days: List(vacationPlan.days),
    };
};

export const fetch = (institutionId: string, embedBehaviors = false) => {
    return RESTClient.getAuthenticatedObservable('v2/vacations', {
        institutionId,
        embedBehaviors,
    }).pipe(
        map((response: any) => {
            return {
                ...response,
                vacations: response.vacations.map(fromApi),
            };
        }),
    );
};

export const fetchSingle = (vacationId: string, includeReplied = true) => {
    return RESTClient.getAuthenticatedObservable('daycare/vacation/show2', {
        vacationId,
        showAll: includeReplied,
    }).pipe(
        map((response: any) => {
            return {
                ...response,
                vacation: fromApi(response.vacation),
            };
        }),
    );
};

export const deleteVacationPlan = (vacationId: string) => {
    return RESTClient.postAuthenticatedObservable(`v2/vacations/${vacationId}/delete`, {});
};
